<script setup>
import { useWebStore } from '@/store/web.js'
const store = useWebStore();
const props = defineProps(['textClass','text','black','file','btnClass'])


const openPdf = () => {
  window.open(props.file, '_blank')
}

</script>
<template>
  <button class="pulse-orange b-r-50px p-2  no-border pointer" @click="openPdf" :class="[btnClass, black?'pulse-black bg-black w400':'pulse-orange bg-orange w300']" :style="store.sharedStyle">
    <p :class="['text-2xl',textClass]" class="InterExtraBold text-white">
      {{text===undefined?store.getLocaleString('h19'):text }}
    </p>
  </button>
</template>